export class ShippingAddress {
  constructor(application_id: number) {
    this.application_id = application_id;
  }

  id: number;
  application_id: number;
  sk_title: string;
  company_name: string | null;
  first_name: string;
  last_name: string;
  street: string;
  street_number: string;
  address_suffix: string;
  country: string;
  city: string;
  post_code: string;
}
